import api from '../callApi';
import { parseAddressNumber, parseAddressStreet } from '../addressParser';

const apiCompleteElectionReminder = (apiRequestData, values, actionCompletedTime) => {
    const request = {
        ...apiRequestData,
        email: values.email,
        firstName: values.firstName,
        lastName: values.lastName,
        street: parseAddressStreet(values.address),
        streetNo: parseAddressNumber(values.address),
        zipCode: values.postalCode,
        notifyResult: values.getUpdates,
        partnerOptIn: values.hasPartnerOptIn,
        actionCompletedTime: actionCompletedTime
    };

    return api
        .post('Widget/CompleteElectionReminderAsync', request, { useFingerprint: true })
        .then(response => {
            return response;
        });
};

export default apiCompleteElectionReminder;
